import { RadioGroup } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { CartaoPasso } from './CartaoPasso';
import type { Valores } from './formulario.utils';
import { OpcaoCartao } from './OpcaoCartao';
import { type CtxPasso, TITULO_PASSO } from './passo.types';

/** Pergunta 1 do roteiro: Sim → tamanho; Não → cadastro (R2). */
export function PassoBrinde({ ctx }: { ctx: CtxPasso }) {
  const { t } = useTranslation(['formulario', 'common']);
  const deseja = ctx.form.watch('deseja');
  const escolha = (x: string) => {
    ctx.escolher('deseja', x as Valores['deseja']);
    ctx.avancar();
  };
  return (
    <CartaoPasso
      titulo={t('formulario:brinde.pergunta')}
      onVoltar={ctx.onVoltar}
      onContinuar={ctx.respondido ? () => escolha(deseja) : undefined}
    >
      <RadioGroup
        name="deseja"
        aria-labelledby={TITULO_PASSO}
        className="grid gap-3 sm:grid-cols-2"
        value={deseja}
        onValueChange={(x) => ctx.escolher('deseja', x as Valores['deseja'])}
      >
        <OpcaoCartao value="sim" label={t('common:yes')} onEscolher={escolha} />
        <OpcaoCartao value="nao" label={t('common:no')} onEscolher={escolha} />
      </RadioGroup>
    </CartaoPasso>
  );
}
